import React from "react";

import { withRouter, Redirect } from "react-router-dom"

import { withTranslation } from "react-i18next"
import { connect,useDispatch} from "react-redux"

class Head extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      referral_code: props.referral_code || 'Linkt-sigmobi',
      //first_name: props?.data?.first_name || 'Linkt',
      //last_name: props?.data?.last_name || 'Sigmobi',
      head : {
        /*
        "links": [
  
          {
            "rel": "apple-touch-icon",
            "href": "%PUBLIC_URL%/logo192.png"
          },
          {
            "rel": "manifest",
            "href": "%PUBLIC_URL%/manifest.json"
          },
          {
            "rel": "stylesheet",
            "id": "hello-elementor-css",
            "href": "https://cdn.sigmobi.com/assets/theme/style.min.css?ver=3.1.1",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "hello-elementor-theme-style-css",
            "href": "https://cdn.sigmobi.com/assets/theme/theme.min.css?ver=3.1.1",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "hello-elementor-header-footer-css",
            "href": "https://cdn.sigmobi.com/assets/theme/header-footer.min.css?ver=3.1.1",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "elementor-frontend-css",
            "href": "https://cdn.sigmobi.com/assets/plugin/frontend.min.css?ver=3.25.10",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "elementor-post-67-css",
            "href": "https://cdn.sigmobi.com/assets/upload/post-67.css?ver=1732987567",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "swiper-css",
            "href": "https://cdn.sigmobi.com/assets/swiper/swiper.min.css?ver=8.4.5",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "e-swiper-css",
            "href": "https://cdn.sigmobi.com/assets/conditionals/e-swiper.min.css?ver=3.25.10",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "widget-text-editor-css",
            "href": "https://cdn.sigmobi.com/assets/plugin/widget-text-editor.min.css?ver=3.25.10",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "e-animation-fadeInUp-css",
            "href": "https://cdn.sigmobi.com/assets/animations/fadeInUp.min.css?ver=3.25.10",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "widget-video-css",
            "href": "https://cdn.sigmobi.com/assets/plugin/widget-video.min.css?ver=3.25.10",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "widget-icon-box-css",
            "href": "https://cdn.sigmobi.com/assets/plugin/widget-icon-box.min.css?ver=3.25.10",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "widget-image-css",
            "href": "https://cdn.sigmobi.com/assets/plugin/widget-image.min.css?ver=3.25.10",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "widget-heading-css",
            "href": "https://cdn.sigmobi.com/assets/plugin/widget-heading.min.css?ver=3.25.10",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "widget-icon-list-css",
            "href": "https://cdn.sigmobi.com/assets/plugin/widget-icon-list.min.css?ver=3.25.10",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "widget-spacer-css",
            "href": "https://cdn.sigmobi.com/assets/plugin/widget-spacer.min.css?ver=3.25.10",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "widget-toggle-css",
            "href": "https://cdn.sigmobi.com/assets/plugin/widget-toggle.min.css?ver=3.25.10",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "widget-social-icons-css",
            "href": "https://cdn.sigmobi.com/assets/plugin/widget-social-icons.min.css?ver=3.25.10",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "e-apple-webkit-css",
            "href": "https://cdn.sigmobi.com/assets/plugin/conditionals/apple-webkit.min.css?ver=3.25.10",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "e-shapes-css",
            "href": "https://cdn.sigmobi.com/assets/plugin/conditionals/shapes.min.css?ver=3.25.10",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "elementor-post-75-css",
            "href": "https://cdn.sigmobi.com/assets/upload/post-75.css?ver=1734626116",
            "media": "all"
          },
          {
            "rel": "stylesheet",
            "id": "google-fonts-1-css",
            "href": "https://fonts.googleapis.com/css?family=Roboto%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2C400%2C400italic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CRoboto+Slab%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2C400%2C400italic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CMontserrat%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2C400%2C400italic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CDM+Sans%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2C400%2C400italic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic&#038;display=swap&#038;ver=6.7.1",
            "media": "all"
          },
          {
            "rel": "canonical",
            "href": "https://sigmobioficial.com/"
          },
          {
            "rel": "shortlink",
            "href": "https://sigmobioficial.com/"
          },
          {
            "type": "image/x-icon",
            "rel": "icon",
            "href": "https://cdn.sigmobi.com/sig-64.ico",
            "sizes": "32x32"
          },
          {
            "type": "image/x-icon",
            "rel": "icon",
            "href": "https://cdn.sigmobi.com/sig-192.ico",
            "sizes": "192x192"
          },
          {
            "type": "image/x-icon",
            "rel": "apple-touch-icon",
            "href": "https://cdn.sigmobi.com/sig-192.ico"
          },
          {
            "type": "image/x-icon",
            "rel": "icon",
            "href": "https://cdn.sigmobi.com/sig-512.ico",
            "sizes": "512x512"
          }
        ],*/
        "meta" : [
          {
            "charset": "utf-8"
          },
          {
            "name": "viewport",
            "content": "width=device-width, initial-scale=1"
          },
          {
            "name": "theme-color",
            "content": "#000000"
          },
          {
            "property": "og:image",
            "content": "https://cdn.sigmobi.com/summary_large_image.png"
          },
          {
            "property": "og:url",
            "content": "https://sigmobi.com"
          },
          {
            "property": "og:type",
            "content": "article"
          },
          {
            "property": "og:title",
            "content": "Sig Mobi: A revolução dos aplicativos, com ganhos para todos!"
          },
          {
            "property": "og:description",
            "content": `Cansado de aplicativos que só beneficiam um lado? Na Sig Mobi, passageiros e motoristas ganham mais! Indicação de ${props?.data?.first_name || 'Linkt' } ${props?.data?.last_name || 'Sigmobi'}. Realize seu cadastro gratuitamente através desse link e experimente a diferença!`
          },
          {
            "name": "twitter:card",
            "content": "summary_large_image"
          },
          {
            "name": "twitter:site",
            "content": "https://sigmobioficial.com"
          },
          {
            "name": "twitter:image",
            "content": "https://cdn.sigmobi.com/summary_large_image.png"
          },
          {
            "name": "twitter:creator",
            "content": "Sigmobi Tecnologia LTDA"
          },
          {
            "name": "twitter:title",
            "content": "Sig Mobi: A revolução dos aplicativos, com ganhos para todos!"
          },
          {
            "name": "twitter:description",
            "content": `Cansado de aplicativos que só beneficiam um lado? Na Sig Mobi, passageiros e motoristas ganham mais! Indicação de ${props?.data?.first_name || 'Linkt' } ${props?.data?.last_name || 'Sigmobi'}. Realize seu cadastro gratuitamente através desse link e experimente a diferença!`
          },
          {
            "name": "msapplication-TileImage",
            "content": "https://cdn.sigmobi.com/lpimg/cropped-LOGO-SIG-MOBI-ALTERADO-Post-para-Instagram-4-e1722864121709-300x300.webp"
          },
          {
            "name": "viewport",
            "content": "width=device-width, initial-scale=1.0, viewport-fit=cover"
          },
          {
            "name": "description",
            "content": "Cansado de aplicativos que só beneficiam um lado? Na Sig Mobi, passageiros e motoristas ganham mais! Realize seu cadastro gratuitamente através desse link e experimente a diferença!"
          },
          {
            "name": "keywords",
            "content": "ajuda ,aplicativodemotorista ,causa ,causasocial ,empatia ,empreendedorismo ,instituições ,justiçasocial ,mobilidadeurbana ,ong ,projetosocial ,rendaextra ,rendaextraemcasa ,rendaextraonline ,revolução ,sigmobi ,terceirosetor rendaextraemcasa"
          },
          {
            "name": "robots",
            "content": "index, follow"
          },
          
        ]
      }
    }
  }

  async componentWillUnmount() {
    /*
    const links = document.querySelectorAll("head link");
    links.forEach(link => {
      document.head.removeChild(link);
    });*/
  }

  componentDidMount() {
  }


  render() {


   const {data, loading} = this.props;  



   this.state.head.meta.forEach(linkData => {
    const linkElement = document.createElement("meta");
  
    Object.entries(linkData).forEach(([key, value]) => {
      linkElement.setAttribute(key, value);
    });
  
    document.head.appendChild(linkElement);
  });

  
   


    return (

      <> </>
     
    );
  }
}

const mapStateToProps = state => {
  const {
    data, loading
  } = state.LedgerProfile
  
  return {
    data, loading
  }
}

export default connect(mapStateToProps)(Head);

/*<head>
          <script type="text/javascript" id="_wpemojiSettings" src="../src/assets/css/_wpemojiSettings.js"/>
        <style id='wp-emoji-styles-inline-css' src="../src/assets/css/wp-emoji-styles-inline-css.css" type="text/css"/>
        <style id='classic-theme-styles-inline-css' src="../src/assets/css/classic-theme-styles-inline-css.css"/>
        <style id='global-styles-inline-css' src="../src/assets/css/global-styles-inline-css.css"/>
        <style src="../src/assets/css/breakpoint.css" type="text/css"/>

    
       
      </head>*/